/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExternalDealFilterMvoDTO
 */
export interface ExternalDealFilterMvoDTO {
  /**
   *
   * @type {number}
   * @memberof ExternalDealFilterMvoDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ExternalDealFilterMvoDTO
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalDealFilterMvoDTO
   */
  lastRunStartDate?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalDealFilterMvoDTO
   */
  lastRunEndDate?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalDealFilterMvoDTO
   */
  nextRunAtDate?: string;
}

/**
 * Check if a given object implements the ExternalDealFilterMvoDTO interface.
 */
export function instanceOfExternalDealFilterMvoDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;

  return isInstance;
}

export function ExternalDealFilterMvoDTOFromJSON(json: any): ExternalDealFilterMvoDTO {
  return ExternalDealFilterMvoDTOFromJSONTyped(json, false);
}

export function ExternalDealFilterMvoDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExternalDealFilterMvoDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    title: !exists(json, "title") ? undefined : json["title"],
    lastRunStartDate: !exists(json, "lastRunStartDate") ? undefined : json["lastRunStartDate"],
    lastRunEndDate: !exists(json, "lastRunEndDate") ? undefined : json["lastRunEndDate"],
    nextRunAtDate: !exists(json, "nextRunAtDate") ? undefined : json["nextRunAtDate"]
  };
}

export function ExternalDealFilterMvoDTOToJSON(value?: ExternalDealFilterMvoDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    title: value.title,
    lastRunStartDate: value.lastRunStartDate,
    lastRunEndDate: value.lastRunEndDate,
    nextRunAtDate: value.nextRunAtDate
  };
}
